import React from 'react'
import { Main } from './components'

const Logistics = () => <Main />

export default Logistics

